import _classCallCheck from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/renovation/ui/pager/info.js)
 * Version: 21.2.4
 * Build date: Mon Dec 06 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["infoText", "pageCount", "pageIndex", "rootElementRef", "totalCount"];
import { createVNode } from "inferno";
import { BaseInfernoComponent } from "@devextreme/runtime/inferno";
import { format } from "../../../core/utils/string";
import messageLocalization from "../../../localization/message";
import { InternalPagerProps } from "./common/pager_props";
export var PAGER_INFO_CLASS = "dx-info";
export var viewFunction = function viewFunction(_ref) {
  var rootElementRef = _ref.props.rootElementRef,
      text = _ref.text;
  return createVNode(1, "div", PAGER_INFO_CLASS, text, 0, null, null, rootElementRef);
};
export var InfoTextProps = {};
var InfoTextPropsType = {
  get pageIndex() {
    return InternalPagerProps.pageIndex;
  },

  get pageCount() {
    return InternalPagerProps.pageCount;
  },

  get totalCount() {
    return InternalPagerProps.totalCount;
  }

};
export var InfoText = /*#__PURE__*/function (_BaseInfernoComponent) {
  _inherits(InfoText, _BaseInfernoComponent);

  function InfoText(props) {
    var _this;

    _classCallCheck(this, InfoText);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InfoText).call(this, props));
    _this.state = {};
    return _this;
  }

  _createClass(InfoText, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return viewFunction({
        props: _extends({}, props),
        infoText: this.infoText,
        text: this.text,
        restAttributes: this.restAttributes
      });
    }
  }, {
    key: "infoText",
    get: function get() {
      var _this$props$infoText;

      return (null !== (_this$props$infoText = this.props.infoText) && void 0 !== _this$props$infoText ? _this$props$infoText : "") || messageLocalization.getFormatter("dxPager-infoText")();
    }
  }, {
    key: "text",
    get: function get() {
      var _this$props2 = this.props,
          pageCount = _this$props2.pageCount,
          pageIndex = _this$props2.pageIndex,
          totalCount = _this$props2.totalCount;
      return format(this.infoText, (pageIndex + 1).toString(), pageCount.toString(), totalCount.toString());
    }
  }, {
    key: "restAttributes",
    get: function get() {
      var _this$props = this.props,
          restProps = _objectWithoutPropertiesLoose(_this$props, _excluded);

      return restProps;
    }
  }]);

  return InfoText;
}(BaseInfernoComponent);
InfoText.defaultProps = InfoTextPropsType;